import React from 'react'

const StoreIcon = () => {
  return (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      // height="66"
      width="57"
      style={{ padding: '1em' }}
      viewBox="0 0 990 1463.4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Store</title>
      <path
        d="M900 315H720v-90C720 100.7 619.3 0 495 0S270 100.7 270 225v90H0v1148.4h990V315h-90zm-540-90c0-74.6 60.4-135 135-135s135 60.4 135 135v90H360v-90zm540 1146.1H90V405h180v180h90V405h270v180h90V405h180v966.1z"
        fill="#FFF"
      />
    </svg>
  )
}

export default StoreIcon
